/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Item_3_SolutionInputs */

const es_home_usecases_item_3_solution = /** @type {(inputs: Home_Usecases_Item_3_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntá: '¿Cómo proceso facturas de proveedores?' Obtenés: Guías, procedimientos y referencias. Autonomía desde el día 1.`)
};

const en_home_usecases_item_3_solution = /** @type {(inputs: Home_Usecases_Item_3_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask: 'How do I process vendor invoices?' Get: Guides, procedures, and references. Autonomy from day 1.`)
};

/**
* | output |
* | --- |
* | "Ask: 'How do I process vendor invoices?' Get: Guides, procedures, and references. Autonomy from day 1." |
*
* @param {Home_Usecases_Item_3_SolutionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_item_3_solution = /** @type {((inputs?: Home_Usecases_Item_3_SolutionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Item_3_SolutionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_item_3_solution(inputs)
	return en_home_usecases_item_3_solution(inputs)
});
export { home_usecases_item_3_solution as "home.usecases.item_3_solution" }